// extracted by mini-css-extract-plugin
module.exports = {"updateActionButton":"EditVlpCustomCard_updateActionButton__YOOnd"};